/**
 * LeftNavMenu - Left sidebar navigation menu for ScrollWizard
 * Icon-only design with tooltips on hover
 * Mobile: Slide-in menu with toggle button
 */
import React, { useState } from 'react';

const LeftNavMenu = ({ sections, currentSection, onNavigate, onSettingsClick }) => {
  const [isOpen, setIsOpen] = useState(false);

  const sectionIcons = {
    config: 'bi-gear-fill',
    players: 'bi-people-fill',
    courts: 'bi-grid-3x3-gap-fill',
    recap: 'bi-file-earmark-text',
    schedule: 'bi-calendar3',
    results: 'bi-clipboard-check',
    ranking: 'bi-trophy-fill'
  };

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleNavigation = (index) => {
    if (sections[index].enabled) {
      onNavigate(index);
      setIsOpen(false);
    }
  };

  return (
    <>
      {!isOpen && (
        <button
          className="left-nav-toggle"
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <i className="bi bi-chevron-right"></i>
        </button>
      )}

      <nav className={`left-nav-menu ${isOpen ? 'open' : ''}`}>
        <ul className="left-nav-list">
          {sections.map((section, index) => (
            <li
              key={section.id}
              className={`left-nav-item ${currentSection === index ? 'active' : ''} ${!section.enabled ? 'disabled' : ''}`}
              onClick={() => handleNavigation(index)}
            >
              <i className={`bi ${sectionIcons[section.id] || 'bi-circle-fill'}`}></i>
              {!section.enabled && <i className="bi bi-lock-fill lock-icon"></i>}
              <span className="nav-tooltip">{section.label}</span>
            </li>
          ))}
        </ul>

        <hr className="left-nav-separator" />

        <button
          className="left-nav-settings"
          onClick={onSettingsClick}
          title="Paramètres"
        >
          <i className="bi bi-sliders"></i>
        </button>
      </nav>

      {isOpen && <div className="left-nav-overlay" onClick={toggleMenu}></div>}
    </>
  );
};

export default LeftNavMenu;
